import * as React from 'react';
import styled from 'styled-components';
import { TagLabel } from 'shared/TagLabel/TagLabel';
import { Typography } from 'components/DesignSystemV2/Typography';
import { UserPixelTracking } from 'utils/userPixelTracking';
import DolInfo from 'shared/DolInfo';
import Button from '@dolstaff/shared/es/Button';
import { colorsV2 } from 'style/colors-v2';
import { IconsLogoFacebook2 } from 'components/Icon/SVGIcons';
import { Link } from 'gatsby';
import { fromScreen } from 'utils/media-query/responsive.util';

const Main = styled.div`
  display: grid;
  gap: 24px;
  .link-messenger {
    width: fit-content;
  }
  .tag-header {
    width: fit-content;
    border-radius: 38px;
  }
  .header-des {
    width: 100%;
  }
  .fb-mess {
    margin-right: 6px;
  }
  .btn-action {
    border-radius: 12px;
  }
  ${fromScreen(776)} {
    .header-des {
      width: 470px;
    }
  }
`;

const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: ${colorsV2.neutral20};
  margin: 8px 0;
`;
const BtnWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
const List = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
  padding-right: 0;
  ${fromScreen(458)} {
    padding-right: 84px;
  }
  ${fromScreen(776)} {
    grid-template-columns: repeat(3, 1fr);
    gap: 40px;
    padding-right: 19px;
  }
`;
const Item = styled.div`
  display: grid;
  gap: 4px;
`;

export const MainHeaderContent = data => {
  const { tagText, title, description, list = [] } = data || {};
  const onClick = () => {
    UserPixelTracking.clickEvent();
  };

  return (
    <Main>
      <TagLabel className="tag-header" text={tagText} color="primary" />
      <Typography
        variant="bold/32-40"
        tabletVariant="bold/40-48"
        desktopVariant="bold/48-56"
        color={colorsV2.black100}
        v3
        dangerouslySetInnerHTML={{
          __html: title
        }}
      />
      <Typography
        className="header-des"
        variant="regular/16-24"
        color={colorsV2.neutral120}
      >
        {description}
      </Typography>
      <DolInfo>
        {({ dolInfo }) => (
          <Link
            target="_blank"
            href={dolInfo.messenger.href}
            rel="noreferrer noopener"
            className="link-messenger"
          >
            <Button
              size="large"
              className="btn-action"
              type="primary"
              marginBottom="0"
              onClick={onClick}
            >
              <BtnWrapper>
                <Typography
                  className="fb-mess"
                  variant="semi-bold/14-24"
                  color={colorsV2.white100}
                >
                  Liên hệ DOL ngay
                </Typography>
                <IconsLogoFacebook2 />
              </BtnWrapper>
            </Button>
          </Link>
        )}
      </DolInfo>
      <Divider />
      <List>
        {list?.map((eachItem, idx) => (
          <Item key={idx}>
            <Typography variant="semi-bold/28-36" color={colorsV2.primary100}>
              {eachItem?.title}
            </Typography>
            <Typography variant="regular/14-20" color={colorsV2.neutral120}>
              {eachItem?.content}
            </Typography>
          </Item>
        ))}
      </List>
    </Main>
  );
};
